import React, { useEffect, useState } from "react";

export type AuctionRemainingTimeProps = {
  endAt: string | null | undefined;
  className?: string;
  // realtime=true で定期更新 (リターン詳細・入札画面)。false なら初回描画のみ (一覧カード)
  realtime?: boolean;
};

type Props = AuctionRemainingTimeProps;

const calcRemaining = (endAt: string | null | undefined): string => {
  if (!endAt) return "終了";
  const endTime = new Date(endAt).getTime();
  if (Number.isNaN(endTime)) return "終了";
  const diffMs = endTime - Date.now();
  if (diffMs <= 0) return "終了";

  const totalSec = Math.floor(diffMs / 1000);
  const days = Math.floor(totalSec / 86400);
  const hours = Math.floor((totalSec % 86400) / 3600);
  const minutes = Math.floor((totalSec % 3600) / 60);
  const seconds = totalSec % 60;

  if (days > 0) return `${days}日 ${hours}時間`;
  if (hours > 0) return `${hours}時間 ${minutes}分`;
  if (minutes > 0) return `${minutes}分 ${seconds}秒`;
  return `${seconds}秒`;
};

const AuctionRemainingTime: React.FC<Props> = ({ endAt, className, realtime = false }) => {
  const [remaining, setRemaining] = useState<string>(calcRemaining(endAt));

  useEffect(() => {
    setRemaining(calcRemaining(endAt));
    if (!realtime) return; // 静的表示は初回計算のみ

    const id = setInterval(() => setRemaining(calcRemaining(endAt)), 1000);
    return () => clearInterval(id);
  }, [endAt, realtime]);

  return <span className={className}>{remaining}</span>;
};

export default AuctionRemainingTime;
